var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "keep-alive",
        { attrs: { include: "glzy,jgqk" } },
        [_c("router-view")],
        1
      ),
      _vm._l(_vm.hasOpenComponentsArr, function (item) {
        return _c(item.name, {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$route.name === item.name,
              expression: "$route.name === item.name",
            },
          ],
          key: item.name,
          tag: "component",
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }